module.exports = __webpack_public_path__ + "img/组1@2x (1).f69f4fb0.png";